import md5 from 'md5';
import { useCallback } from 'react';

const MAX_ID_LENGTH = 12;

export const useJumpLink = () => {
  const getJumpLinkIdentifier = useCallback((jumpLinkLabel: string) => {
    return `gntc-${md5(jumpLinkLabel).slice(0, MAX_ID_LENGTH)}`;
  }, []);

  return {
    getJumpLinkIdentifier,
  };
};
